import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Hoverable } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { usePagination } from './usePagination';

export const Pagination = memo(
  ({ currentPage, totalCount, pageSize, onChange, style }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();

    const data = usePagination({
      currentPage,
      totalCount,
      pageSize,
      displayPageCount: 6,
    });

    return (
      <View style={[style, styles.container]}>
        <Button
          variant="transparent"
          title={dictionary.first}
          onPress={() => onChange(0)}
        />
        <Space />
        {data.map((item, index) => {
          const isCurrentPage = currentPage + 1 === item;
          const isCollapseButton = item > 0;
          return (
            <Hoverable>
              {(isHovered) => (
                <Button
                  variant={
                    isCurrentPage
                      ? 'circle'
                      : isHovered
                      ? 'circleHover'
                      : 'transparent'
                  }
                  style={styles.pageButton}
                  title={isCollapseButton ? `${item}` : '...'}
                  onPress={() => {
                    const actualItem =
                      item > 0
                        ? item
                        : item === -1
                        ? data[index + 1] - 1
                        : data[index - 1] + 1;
                    onChange(actualItem - 1);
                  }}
                />
              )}
            </Hoverable>
          );
        })}
        <Space />
        <Button
          variant="transparent"
          title={dictionary.last}
          onPress={() => onChange(data[data.length - 1] - 1)}
        />
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pageButton: {
    width: 48,
    height: 48,
    marginHorizontal: 3,
  },
}));
